import { jwtDecode, JwtPayload } from "jwt-decode";

interface DecodedToken extends JwtPayload {
  role_id?: number;
  sub?: string;
  user_id: any,
  fullname: any
  contractor_id?: number
}

const getRoleId = (token: any) => {
  if (!token) {
    return null;
  }
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    return decoded?.role_id || null;
  } catch (error) {
    return null;
  }
};

const getTokenExpiration = (token: any) => {
  if (!token) {
    return null;
  }
  try {
    const decode = jwtDecode<DecodedToken>(token);
    if (decode.exp) {
      return new Date(decode.exp * 1000);
    }
    return null;
  } catch (error) {
    localStorage.removeItem("app_atkey");
    localStorage.removeItem("app_rtkey");
    console.error("خطا  اهراز هویت لطفت مجدد وارد شوید", error);
    return null;
  }
};

const getUsername = (token: any | null): string | null => {
  if (!token) return null;
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    return decoded?.user_id || null;
  } catch (error) {
    return null;
  }
};

const getfullnameFromToken = (token: any | null): string | null => {
  if (!token) return null;
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    return decoded?.fullname || null;
  } catch (error) {
    return null;
  }
};

const getContractorId = (token: any | null): number | null => {
  if (!token) return null;
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    return typeof decoded?.contractor_id === "number"
      ? decoded.contractor_id
      : null;
  } catch (error) {
    return null;
  }
};

export {
  getTokenExpiration,
  getRoleId,
  getUsername,
  getfullnameFromToken,
  getContractorId,
};
